import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const opacityMap: OpacityMap = {
  default: '0.4',
  hover: '0.6',
  dark: '0.9',
};
const Mute32: FC<IconV2Props> = ({ icon, chroma, className }) => {
  const chromaType = chroma as string;
  const opacity = opacityMap[chromaType] || '';
  return (
    <svg
      className={cn(s.svg32, `svg-icon--${icon}`, className)}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      data-icon={`${icon}-32`}
    >
      <g
        id="Video-Content"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="UI-Sheet" transform="translate(-112.000000, -544.000000)">
          <g id="Group-4-Copy" transform="translate(86.000000, 471.000000)">
            <g
              id="videoControllerSound-Copy"
              transform="translate(26.000000, 73.000000)"
            >
              <g id="controllerbg(60%)" fill="#000000" fillOpacity={opacity}>
                <circle id="Oval" cx="16" cy="16" r="16" />
              </g>
              <g
                id="Sound"
                transform="translate(10.793694, 9.793694)"
                fill="#FFFFFF"
                fillRule="nonzero"
              >
                <g id="icon">
                  <path
                    d="M1,3.826 L7.999,11.525 L8,13 L3.62960354,9.64756447 C3.55834707,9.59383954 3.47608777,9.55784384 3.38989889,9.5432038 L3.30266211,9.53581662 L1.00010029,9.53581662 L1,3.826 Z M0.739940073,0 L11.4126129,11.7399401 L10.6726728,12.4126129 L0,0.672672794 L0.739940073,0 Z M8,0 L7.999,6.322 L4.614,2.599 L8,0 Z"
                    id="Combined-Shape"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Mute32;
